"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const useCache_1 = __importDefault(require("./useCache"));
var QueryActionTypes;
(function (QueryActionTypes) {
    QueryActionTypes["LOADING"] = "LOADING";
    QueryActionTypes["SUCCESS"] = "SUCCESS";
    QueryActionTypes["FAIL"] = "FAIL";
})(QueryActionTypes || (QueryActionTypes = {}));
const queryReducer = (state, action) => {
    switch (action.type) {
        case QueryActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { error: null, loading: true });
        case QueryActionTypes.SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, loading: false });
        case QueryActionTypes.FAIL:
            return Object.assign(Object.assign({}, state), { error: action.error, loading: false });
        default:
            throw new Error('Undefined action type');
    }
};
const useQuery = (isServer, data, memberId, siteId, path, leftMenuPath, userparam, previewDate) => {
    const [store, dispatch] = (0, react_1.useReducer)(queryReducer, {
        loading: !data,
        data: data,
    });
    const [cache, setCache] = (0, useCache_1.default)(isServer, memberId, siteId, path);
    (0, react_1.useEffect)(() => {
        const headers = (0, utils_1.cleanObj)({
            credentials: 'same-origin',
            'Content-Type': 'application/json',
            'x-vp-device': '10',
            'x-vp-mid': memberId ? `${memberId}` : '',
            'x-vp-siteid': `${siteId}`,
        });
        const fetchHeaderData = async (headers) => {
            const getHomesParams = new URLSearchParams((0, utils_1.cleanObj)({ previewDate: previewDate || '', siteId: `${siteId}`, userparam: userparam || '' }));
            const responses = await Promise.all([
                `${path}${constants_1.ENDPOINTS.getHeaders}`,
                `${path}${constants_1.ENDPOINTS.getHomeHeaders}?${getHomesParams}`,
                `${leftMenuPath}${constants_1.ENDPOINTS.headerLeftMenu}/${siteId}`,
            ].map(async (r) => {
                const response = await fetch(r, {
                    method: 'GET',
                    headers,
                });
                if (!response.ok)
                    throw new Error(response.statusText);
                return response.json();
            }));
            const [header, homes, lateralMenu] = responses;
            const payload = Object.assign({ header, homes }, (lateralMenu && { lateralMenu }));
            if (payload && payload.header && payload.homes)
                setCache(payload);
            dispatch({ payload, type: QueryActionTypes.SUCCESS });
        };
        const fetchLeftMenuOnly = async (headers) => {
            const response = await fetch(`${leftMenuPath}${constants_1.ENDPOINTS.headerLeftMenu}/${siteId}`, {
                method: 'GET',
                headers,
            });
            if (!response.ok)
                throw Error(response.statusText);
            const lateralMenu = await response.json();
            const payload = Object.assign(Object.assign({}, data), { lateralMenu });
            if (payload && payload.header && payload.homes && payload.lateralMenu)
                setCache(payload);
            dispatch({ payload, type: QueryActionTypes.SUCCESS });
        };
        (async () => {
            try {
                if (!data) {
                    dispatch({ type: QueryActionTypes.LOADING });
                    if (cache) {
                        dispatch({ payload: cache, type: QueryActionTypes.SUCCESS });
                    }
                    else {
                        await fetchHeaderData(headers);
                    }
                }
                else {
                    await fetchLeftMenuOnly(headers);
                }
            }
            catch (err) {
                dispatch({ error: new Error(err.message), type: QueryActionTypes.FAIL });
            }
        })();
    }, [data, isServer, memberId, siteId, path, previewDate, userparam]);
    return Object.assign({}, store);
};
exports.default = useQuery;
